'use strict';
import Firebase from 'firebase';
const angular = require('angular');
const {extend, forEach, isArray, isFunction, isObject} = angular;
const without = require('lodash/without');

import {keyIsValid, sanitizeKey, sanitizeObject} from './util-methods';

// Needs work.
export function FirebaseUtilProvider() {
  let fbURL = '';
  let firebaseRootReference = null;

  return {
    firebaseURL: function (newFbURL) {
      if (typeof newFbURL === 'undefined') {
        return fbURL;
      }
      fbURL = newFbURL;
    },
    firebaseRootReference: function (newFirebase) {
      if (typeof newFirebase === 'undefined') {
        return firebaseRootReference;
      }
      firebaseRootReference = newFirebase;
    },
    $get: [
      '$window',
      '$timeout',
      '$q',
      '$firebase',
      'EventBus',
      function (
        $window,
        $timeout,
        $q,
        $firebase,
        EventBus,
      ) {
        if (fbURL === '') throw new Error('You must configure a Firebase URL with FirebaseUtilProvider.firebaseURL()');
        if (firebaseRootReference === null) firebaseRootReference = new Firebase(fbURL);

        const FirebaseService = {
          generateKey: generateKey,
          sanitizeKey: sanitizeKey,
          sanitizeObject: sanitizeObject,
          push: push,
          remove: remove,
          set: set,
          update: update,
          read: read,
          watchDynamicKeyedObject: watchDynamicKeyedObject,
          syncFiltered: syncFiltered,
          syncDynamic: syncDynamic,
          syncObject: syncObject,
          syncArray: syncArray,
          firebaseRef: firebaseRef,
          keyIsValid: keyIsValid
        };

        function generateKey() {
          return firebaseRef().push().key();
        }

        /**
         * Saves the data value to the specified path in Firebase, optionally saving the push uid as a property in the object (for objects).
         * @param path to save the data to
         * @param data the value to save
         * @param saveUID if true, saves the push UID in the object before saving it on the "uid" property
         * @returns promise that resolves to the push UID.
         */
        function push(path, data, saveUID) {
          return new Promise((resolve, reject) => {
            const pushRef = FirebaseService.firebaseRef(path).push();
            const pushUID = pushRef.key();

            if (saveUID && isObject(data)) {
              data.uid = pushUID;
            }

            const sanitizedData = sanitizeObject(data);
//            console.log('data', data);
//            console.log('sanitizedData', sanitizedData);

            pushRef.set(sanitizedData, (error) => {
              if (error) {
                reject(error);
              } else {
                resolve(pushUID);
              }
            });
          });
        }

        function remove(path) {
          return new Promise((resolve, reject) => {
            FirebaseService.firebaseRef(path).remove((error) => {
              if (error) {
                reject(error);
              } else {
                resolve();
              }
            });
          });
        }

        /**
         * Saves the data to the specified path in Firebase
         * @param path
         * @param data
         * @returns {*}
         */
        function set(path, data) {
          return new Promise((resolve, reject) => {
            const sanitizedData = sanitizeObject(data);

            FirebaseService.firebaseRef(path).set(sanitizedData, (error) => {
              if (error) {
                reject(error);
              } else {
                resolve();
              }
            });
          });
        }

        /**
         * Updates the data in the specified path in Firebase
         * @param path
         * @param data
         * @returns {*}
         */
        function update(path, data) {
          return new Promise((resolve, reject) => {
            const sanitizedData = sanitizeObject(data);

            FirebaseService.firebaseRef(path).update(sanitizedData, (error) => {
              if (error) {
                reject(error);
              } else {
                resolve();
              }
            });
          });
        }

        function read(path) {
          return new Promise((resolve, reject) => {
            FirebaseService.firebaseRef(path).once('value', (ss) => {
              resolve(ss.val());
            }, (error) => {
              reject(error);
            });
          });
        }

        // watchDynamicKeyedObject should be its own factory, probably
        //---------------------------

        /**
         * <code>
         *   var exampleOptions = {
           *     path: 'organizations',
           *     filter: {
           *       getKey: function () {
           *         return AuthService.user.uid;
           *       },
           *       path: 'users/newUserId/organizations',
           *       pathParam: 'newUserId',
           *       topic: 'event:UserChanged'
           *     }
           *   };
         * </code>
         * @deprecated
         */
        function watchDynamicKeyedObject(options, $scope) {
          options = options || {};
          options.events = options.events || {};
          if (options.filter) options.filter.events = options.filter.events || {};

          var q = $q.defer();
          var loaded = false, resolved = false;

          var childRef, filterRef, childOff;
          var data = {
            $keys: [], $refs: {}, $offs: {}, $listeners: {},
            $filter: {$ref: null, $key: null, $values: [], $off: null, $renderedPath: ''}
          };

          var eventHandler = function ($event, message) {
            var key = getKey(options, message, true);
            //var key = options.filter.getKey();
            var oldPath = data.$filter.$renderedPath;
            data.$filter.$renderedPath = options.filter.path.replace(options.filter.pathParam, key);
            filterRef = FirebaseService.firebaseRef(data.$filter.$renderedPath);
            data.$filter.$ref = filterRef;

            if (oldPath === data.$filter.$renderedPath) {
              return data;
            }

            __cleanOldData(data);

            var filterChildAddedOff = data.$filter.$ref.on('child_added', function (ss) {
              data.$filter.$values[ss.key()] = ss.val();
              addData(ss.key());
            });

            var filterChildChangedOff = data.$filter.$ref.on('child_changed', function (ss) {
              data.$filter.$values[ss.key()] = ss.val();
            });

            var filterChildRemovedOff = data.$filter.$ref.on('child_removed', function (ss) {
              delete data.$filter.$values[ss.key()];
              removeData(ss.key());
            });

            // resolve after initial load of data
            data.$filter.$ref.once('value', function () {
              loaded = true;
            });

            data.$filter.$off = function () {
              filterRef.off('child_added', filterChildAddedOff);
              filterRef.off('child_changed', filterChildChangedOff);
              filterRef.off('child_removed', filterChildRemovedOff);
            };

            function addData(key) {
              $timeout(function () {
                data.$keys.push(key);

                childRef = FirebaseService.firebaseRef(options.path).child(key);
                data.$refs[key] = childRef;

                childOff = data.$refs[key].on('value', function (ss) {
                  data[key] = ss.val();
                  data[key].$id = ss.key();
                });
                data.$offs[key] = function () {
                  childRef.off('value', childOff);
                };

                if (loaded && !resolved) {
                  $timeout(function () {
                    q.resolve(data);
                    resolved = true;

                    if (options.filter.events.loaded) {
                      EventBus.broadcast(options.filter.events.loaded);
                    }
                  }, 100);
                }
              });
            }

            function removeData(key) {
              $timeout(function () {
                data.$keys = without(data.$keys, key);

                //data.$keys.push(key);
                delete data[key];
                data.$offs[key]();
                delete data.$refs[key];
              });
            }

          };

          //eventHandler();
          EventBus.on(options.filter.events.triggerUpdate, eventHandler, $scope);

          return q.promise;
        }

        function __cleanOldData(data) {
          if (!data) return data;
          if (data.$filter && typeof data.$filter.$off === 'function') {
            data.$filter.$off();
          } else {
            //console.log('__cleanOldData:' + $event + ': no previous filter connection');
          }
          if (typeof data.$off === 'function') {
            data.$off();
          } else {
            //console.log('__cleanOldData:' + $event + ': no previous data connection');
          }

          if (data.$keys && data.$keys.length > 0) {
            for (var i = 0; i < data.$keys.length; i++) {
              if (data.$offs && data.$offs[data.$keys[i]] && typeof data.$offs[data.$keys[i]] === 'function') {
                data.$offs[data.$keys[i]].$off();
              }
              delete data[data.$keys[i]];
            }
          }

          data.$keys = [];
          data.$refs = {};
          data.$offs = {};
        }

        /**
         * @deprecated
         */
        function syncFiltered(options, $scope) {
          options = options || {};

          var data = {
            $keys: [], $refs: {}, $offs: {}, $listeners: {}, $loaded: null,
            $filter: {$ref: null, $key: null, $values: [], $off: null}
          };

          data.$loadingHelper = $q.defer();
          data.$loadingHelper.loaded = false;
          data.$loadingHelper.resolved = false;
          data.$loaded = function () {
            return data.$loadingHelper.promise;
          };
          data.$filter.$ref = FirebaseService.firebaseRef(options.filter.path);

          var filterChildAddedOff = data.$filter.$ref.on('child_added', function (ss) {
            data.$filter.$values[ss.key()] = ss.val();
            __addData(data, options.path, ss.key());
          });

          var filterChildChangedOff = data.$filter.$ref.on('child_changed', function (ss) {
            data.$filter.$values[ss.key()] = ss.val();
          });

          var filterChildRemovedOff = data.$filter.$ref.on('child_removed', function (ss) {
            delete data.$filter.$values[ss.key()];
            __removeData(data, ss.key());
          });

          // resolve after initial load of data
          data.$filter.$ref.once('value', function () {
            data.$loadingHelper.loaded = true;
          });

          data.$filter.$off = function () {
            data.$filter.$ref.off('child_added', filterChildAddedOff);
            data.$filter.$ref.off('child_changed', filterChildChangedOff);
            data.$filter.$ref.off('child_removed', filterChildRemovedOff);
          };

          if ($scope) {
            $scope.$on("$destroy", function () {
              __destroy(data);
            });
          }

          return data;
        }

        function __addData(data, path, key) {
          var childRef, childOff;
          $timeout(function () {
            data.$keys.push(key);

            childRef = FirebaseService.firebaseRef(path).child(key);
            data.$refs[key] = childRef;

            childOff = data.$refs[key].on('value', function (ss) {
              data[key] = ss.val();
              data[key].$id = ss.key();
            });
            data.$offs[key] = function () {
              childRef.off('value', childOff);
            };

            if (data.$loadingHelper.loaded && !data.$loadingHelper.resolved) {
              $timeout(function () {
                data.$loadingHelper.resolve();
                data.$loadingHelper.resolved = true;
              }, 100);
            }
          });
        }

        function __removeData(data, key) {
          $timeout(function () {
            data.$keys = without(data.$keys, key);

            delete data[key];
            data.$offs[key]();
            delete data.$refs[key];
          });
        }

        function __destroy(data) {
          if (data && data.$offs) {
            forEach.each(data.$offs, function (off) {
              isFunction(off) && off();
            });
          }

          if (data && data.$filter && typeof data.$filter.$off === 'function') {
            data.$filter.$off();
          }
        }

        // Public methods
        //---------------------------

        function syncObject(path, factoryConfig) {
          return syncData.apply(null, arguments).$asObject();
        }

        function syncArray(path, factoryConfig) {
          return syncData.apply(null, arguments).$asArray();
        }

        /**
         *
         * @deprecated
         * @param options
         * @param $scope
         * @returns $firebase.$asObject() or .$asArray()
         */
        function syncDynamic(options, $scope) {
          options = options || {};
          options.events = options.events || {};
          //var q;// = $q.defer();
          var data = {$renderedPath: '', ref: null}; // explicitly define data.ref. declares simplifies if statements

          var eventHandler = function ($event, message) {
            //console.log("FirebaseService:syncDynamic:event triggered: ", $event.name, message);
            var key = getKey(options, message);

//          if (message && message.id) { key = message.id; }
//          else {
//            if (typeof options.getKey === 'function')
//              key = options.getKey();
//          }
            if (!keyIsValid(key)) {
              data.$renderedPath = '';
              if (data.ref !== null && typeof data.ref.$destroy === 'function') {
                data.ref.$destroy();
                //cleanData(data);
              }
              return;

              // key is defined.
              // check if the path has changed
            } else {
              var oldPath = data.$renderedPath;
              data.$renderedPath = options.path.replace(options.pathParam, key);
              //console.log("FirebaseService:syncDynamic:updated path", data.$renderedPath);

              if (oldPath === data.$renderedPath) return;
            }

            // the path has changed, delete the existing reference and load the new one.
            if (data.ref !== null && typeof data.ref.$destroy === 'function') {
              data.ref.$destroy();
              //cleanData(data);
              return;
            }

            data.ref = FirebaseService[options.method](data.$renderedPath);
            //extend(data, ref);
            //data.ref.$loaded().then(function() { console.log('resolved syncDynamic ' + data.ref.lastOrg); q.resolve(data); });

            if (options.events.loaded) {
              data.ref.$loaded().then(function () {
                EventBus.broadcast(options.events.loaded);
              });
            }
            //console.log("FirebaseService:syncDynamic:updated ref", data);
          };

          //helper function to reset data
//        function cleanData(d) {
//          if (d && typeof d.$destroy === 'function') d.$destroy();
//
//          d.prototype = {};
//
//          for (var member in d) delete d[member];
//        }

          if ($scope) {
            $scope.$on('$destroy', function () {
              if (data.ref !== null && typeof data.ref.$destroy === 'function') {
                data.ref.$destroy();
              }
            })
          }

          //eventHandler();
          EventBus.on(options.events.triggerUpdate, eventHandler, $scope);

          return data;
          //return q.promise; //q deferred in initial call of the event handler
        }

        /**
         * Create a $firebase reference with just a relative path. For example:
         *
         * <code>
         *   function(syncData) {
           *    // a regular $firebase ref
           *    $scope.widget = syncData('widgets/alpha');
           *
           *    // or automatic 3-way binding
           *    syncData('widgets/alpha').$bind($scope, 'widget');
           *   }
         * </code>
         *
         * Props is the second param passed into $firebase. It can also contain limit, startAt, endAt,
         * and they will be applied to the ref before passing into $firebase
         *
         * @function
         * @name syncData
         * @param {String|Array...} path relative path to the root folder in Firebase instance
         * @param {object} [props]
         * @return a Firebase instance
         */
        function syncData(path, props) {
          var ref = FirebaseService.firebaseRef(path);
          props = extend({}, props);
          forEach(['limit', 'startAt', 'endAt'], function (k) {
            if (props.hasOwnProperty(k)) {
              var v = props[k];
              ref = ref[k].apply(ref, isArray(v) ? v : [v]);
              delete props[k];
            }
          });
          return $firebase(ref, props);
        }

        // Read the key from available sources for the dynamic Firebase access methods
        function getKey(options, message, forFilter) {
          if (message && message.id) {
            return message.id;
          }
          else {
            if (forFilter) {
              if (options && options.filter && typeof options.filter.getKey === 'function')
                return options.filter.getKey();
            } else {
              if (options && typeof options.getKey === 'function')
                return options.getKey();
            }
          }
          return '';
        }

        /**
         * Example:
         * <code>
         *    function(firebaseRef) {
           *       var ref = firebaseRef('path/to/data');
           *    }
         * </code>
         *
         * @function
         * @name firebaseRef
         * @param {String|Array...} [path] relative path to the root folder in Firebase instance
         * @return {Window.Firebase} a Firebase instance
         */
        function firebaseRef(path) {
          var ref = firebaseRootReference;
          var args = Array.prototype.slice.call(arguments);
          if (args.length) {
            ref = ref.child(__pathRef(args));
          }
          return ref;
        }

        function __pathRef(args) {
          for (var i = 0; i < args.length; i++) {
            if (isArray(args[i])) {
              args[i] = __pathRef(args[i]);
            }
            else if (typeof args[i] !== 'string') {
              throw new Error('Argument ' + i + ' to firebaseRef is not a string: ' + args[i]);
            }
          }
          return args.join('/');
        }

        return FirebaseService;
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/AngularFire-util.js